import { Heading, LayoutVerticalSpacer, useMediumFromMediaQuery } from '@madpaws/design-system';
import React from 'react';

import { PAN_ELEMENT_ID } from '~/utils/area10ProgramaticContent/constants';
import { useArea10CmaxScript } from '~/utils/area10ProgramaticContent/hooks';

import styles from './SearchSeoProgrammaticContent.module.css';
import { Card } from '../Card/Card';

type Props = {
  articleId: string;
  fallbackContent?: React.ReactElement;
  heading: string;
};

export const SearchSeoProgrammaticContent = ({
  articleId,
  fallbackContent,
  heading,
}: Props): React.ReactElement => {
  const isMediumFromViewport = useMediumFromMediaQuery();
  const { error } = useArea10CmaxScript(articleId);

  if (error) {
    return fallbackContent || <></>;
  }

  return (
    <Card>
      <LayoutVerticalSpacer space="large1x">
        <Heading size={isMediumFromViewport ? 'small2x' : 'small3x'}>{heading}</Heading>
        <div className={styles.wrapper} id={PAN_ELEMENT_ID}></div>
      </LayoutVerticalSpacer>
    </Card>
  );
};
